import axios from 'axios'

/**
 * @desc Fetches all credit return availability rules for the specified supplier
 * @param {String} supplierId
 */
export const fetchCreditReturnAvailabilityRules = (supplierId) =>
  axios
    .get(
      `/authenticated/supplier/${supplierId}/credit-return-availability-rules`
    )
    .then((res) => res.data)

/**
 * @desc Create a new credit return availability rule for the specified supplier
 * @param {String} supplierId
 */
export const addCreditReturnAvailabilityRule = (supplierId, payload) =>
  axios
    .post(
      `/authenticated/supplier/${supplierId}/credit-return-availability-rules`,
      payload
    )
    .then((res) => res.data)

/**
 * @desc Update an existing credit return availability rule for the specified supplier
 * @param {String} supplierId
 * @param {String} ruleId
 */
export const updateCreditReturnAvailabilityRule = (
  supplierId,
  ruleId,
  payload
) =>
  axios
    .put(
      `/authenticated/supplier/${supplierId}/credit-return-availability-rules/${ruleId}`,
      payload
    )
    .then((res) => res.data)

/**
 * @desc Delete a credit return availability rule for the specified supplier
 * @param {String} supplierId
 * @param {string} ruleId
 */
export const deleteCreditReturnAvailabilityRule = (supplierId, ruleId) =>
  axios
    .delete(
      `/authenticated/supplier/${supplierId}/credit-return-availability-rules/${ruleId}`
    )
    .then((res) => res.data)
